module.exports = __webpack_public_path__ + "static/media/image-768.4ae52d8e.jpg";